import { Vue, options } from '@vendor/vue'

// NOTE: to enable offline plugin, uncomment the following line and ensure it is enabled in `config.build.js`
// import '@vendor/offline-plugin-runtime'

// Main Vue instance
new Vue(options)



// WEBPACK FOOTER //
// ./src/main.js